import { createSlice } from "@reduxjs/toolkit";
import { Asset } from "../models/Asset";

export const AssetInitialState: {
	areasList: Asset[];
	allAssets: Asset[];
	plantAssetId: number;
} = {
	areasList: [],
	allAssets: [],
	plantAssetId: 1,
};

export const AssetReducer = createSlice({
	name: "__",
	initialState: AssetInitialState,
	reducers: {
		setAreasList(state, { payload }) {
			state.areasList = payload;
		},
		setAllAssets(state, { payload }) {
			state.allAssets = payload;
		},
		setPlantAssetId(state, { payload }) {
			state.plantAssetId = payload;
		},
	},
});
